import { Sun, Moon } from 'lucide-react';
import { useTheme } from '@/hooks/use-theme';

export const ThemeToggle = ({ className = '' }) => {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      className={`relative inline-flex items-center justify-center h-9 w-9 rounded-full border border-border bg-card hover:bg-secondary transition-colors ${className}`}
    >
      <Sun className={`h-4 w-4 absolute transition-all ${isDark ? 'opacity-0 rotate-90 scale-50' : 'opacity-100 rotate-0 scale-100'}`} />
      <Moon className={`h-4 w-4 absolute transition-all ${isDark ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 -rotate-90 scale-50'}`} />
    </button>
  );
};

export default ThemeToggle;
